/**
 * @ngdoc directive
 * @name eventix.common.directives:eventSelector
 * @restrict element
 * @description
 * A dropdown selector for selecting an event (filterable by past or upcoming)
 *
 * @param {Array<Event>} events An optional list of events that will disable the filter
 * @param {String} filter The current filter
 * @param {Expression} ngModel The container for selected event
 */
/**
 * @ngdoc directive
 * @name eventix.common.directives:ticketSelector
 * @restrict element
 * @description
 * A combination of event/ticket selector dropdowns allowing you to filter and select one or more tickets
 *
 * @param {Event} event The currently selected event for which tickets are shown
 * @param {Expression} ngModel Currently selected tickets
 * @param {Expression} eventChange A callback for when the event is changed, e.g.: `event-change="callback(event)"`
 */
export default angular.module('eventix.common.directives.eventSelector', [])
    .component('eventSelector', {
        bindings: { events: '<?', filter: '=?' },
        require: { ngModel: 'ngModel' },
        template: `<div ng-class="{'input-group': $ctrl.filter}">
    <tx-select btn-class="form-control"
               placeholder="{{ 'common.action.select_an_event' | translate }}"
               tx-options="event as event.name for event in $ctrl.events"
               sublabel="daterange"
               ng-model="$ctrl.selected"
               multiple="false"></tx-select>
    <div class="input-group-btn" ng-show="$ctrl.filter" uib-dropdown>
        <button type="button"
                class="btn btn-white"
                uib-dropdown-toggle>
            <i ng-hide="$ctrl.busy" class="fa fa-filter"></i>
            <i ng-show="$ctrl.busy" class="fa fa-spin fa-spinner"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>
            <li><a ng-click="$ctrl.query('all')"><i class="fa fa-globe"></i> {{ 'models.event.filters.all_events' | translate }}</a></li>
            <li><a ng-click="$ctrl.query('upcoming')"><i class="fa fa-rocket"></i> {{ 'models.event.filters.upcoming_events' | translate }}</a></li>
            <li><a ng-click="$ctrl.query('past')"><i class="fa fa-history"></i> {{ 'models.event.filters.past_events' | translate }}</a></li>
        </ul>
    </div>
</div>`,
        controller: EventSelectorController
    })
    .component('ticketSelector', {
        bindings: { event: '=?', eventChange: '&?', filter: '=?', events: '=?' },
        require: { ngModel: 'ngModel' },
        controller: TicketSelectorController,
        template: `<div class="row">
    <div class="col-xs-6">
        <event-selector ng-model="$ctrl.event" ng-change="$ctrl.notifyChange()" filter="$ctrl.filter" events="$ctrl.events"></event-selector>
    </div>
    <div class="col-xs-6">
        <tx-select tx-options="ticket as ticket.name for ticket in $ctrl.tickets"
                   ng-model="$ctrl.selectedTickets"
                   placeholder="{{ 'common.action.select_tickets' | translate }}"
                   ng-disabled="!$ctrl.event"
                   btn-class="form-control"
                   multiple></tx-select>
    </div>
</div>`
    }).name;

function TicketSelectorController(Event, $scope, $attrs) {
    const $ctrl = this;

    $ctrl.$postLink = function() {
        $ctrl.selectAllTickets = _.has($attrs, 'selectAllTickets');
        $ctrl.eventChange = $ctrl.eventChange || angular.noop;
        $scope.$watch('$ctrl.ngModel.$modelValue', v => {
            $ctrl.selectedTickets = v;
        });
        $scope.$watch('$ctrl.selectedTickets', v => {
            if(v !== $ctrl.ngModel.$modelValue)
                $ctrl.ngModel.$setViewValue(v);
        });
        $scope.$watch('$ctrl.event', event => {
            if(event) {
                event.$queryTicket().then(t => {
                    $ctrl.tickets = t;
                    $ctrl.selectedTickets = $ctrl.selectAllTickets ? t.slice(0) : [];
                });
            }
        });
    };

    $ctrl.notifyChange = function() {
        $ctrl.eventChange({ event: $ctrl.event });
    };
}

function EventSelectorController($scope, $q, $element, $attrs, Event, DateRangeHelper) {
    const $ctrl = this;
    $ctrl.$onInit = function() {
        $ctrl.query($ctrl.filter || 'upcoming');

        $scope.$watch('$ctrl.ngModel.$modelValue', value => {
            if(value)
                $ctrl.selected = value;
        });
        $scope.$watch('$ctrl.selected', value => {
            if(value)
                $ctrl.ngModel.$setViewValue(value);
        });
    };

    $ctrl.query = function(type) {
        $ctrl.busy = true;
        var promise = type === 'all' ? Event.query() : Event.queryFilter(type);
        promise.then(events => {
            let promises = _.map(events, event => event.$queryEventDate().then(d => [event, d]));
            return $q.all(promises);
        }).then(eventsWithDates => {
            $ctrl.busy = false;
            $ctrl.filter = type;
            var events = _.map(eventsWithDates, eventWithDates => {
                var event = eventWithDates[0];
                var dates = eventWithDates[1];
                event.start = _.minBy(dates, 'start').start;
                event.end = _.maxBy(_.filter(dates, d => !/proxy date/i.test(d.name)), 'end').end;
                event.daterange = DateRangeHelper.format(event.start, event.end);
                return event;
            });
            $ctrl.events = _.orderBy(events, 'start', type === 'upcoming' ? 'asc' : 'desc');
        }, () => {
            $ctrl.busy = false;
        });
    };
}
